import React, { useState } from 'react';
import { minisitePost } from '../utils/minisiteApi';
import { hasModule } from '../utils/minisiteOccasions';

// Formulaire de réponse des invités, natif au mini-site (pas de service externe). Les questions
// affichées dépendent des réglages RSVP de l'éditeur (params.rsvp_*). `preview` : rendu dans
// l'aperçu de l'éditeur ou la démo de la fiche produit, l'envoi est désactivé.
const MinisiteRsvpForm = ({ slug, params, preview }) => {
  const [nom, setNom] = useState('');
  const [presence, setPresence] = useState(null);
  const [nbPersonnes, setNbPersonnes] = useState(1);
  const [nbEnfants, setNbEnfants] = useState(0);
  const [reponses, setReponses] = useState([]);
  const [repas, setRepas] = useState('');
  const [allergies, setAllergies] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState({ sending: false, sent: false, error: '' });

  // Choix du menu et questions sur mesure : module « rsvp_avance » (minisiteModules.json).
  const avance = hasModule(params, 'rsvp_avance');
  const questions = avance && Array.isArray(params.rsvp_questions) ? params.rsvp_questions.filter(Boolean).slice(0, 3) : [];
  const repasOptions = avance ? (params.rsvp_repas_options || '').split(',').map((o) => o.trim()).filter(Boolean) : [];
  const closed = params.rsvp_date_limite && new Date().toISOString().slice(0, 10) > params.rsvp_date_limite;

  if (closed) return <p className="ms-muted">Les réponses sont closes.</p>;
  if (status.sent) {
    return <p className="ms-texte">Merci {nom.split(' ')[0]}, votre réponse est bien enregistrée&nbsp;!</p>;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (preview) return;
    if (presence === null) {
      setStatus({ sending: false, sent: false, error: 'Merci d\'indiquer si vous serez présent.' });
      return;
    }
    setStatus({ sending: true, sent: false, error: '' });
    minisitePost('addMinisiteRsvp', {
      slug, nom, presence, nb_personnes: nbPersonnes, nb_enfants: nbEnfants, repas, allergies, message, reponses,
    })
      .then((data) => setStatus({
        sending: false, sent: !!data?.success, error: data?.success ? '' : (data?.message || 'Envoi impossible'),
      }))
      .catch(() => setStatus({ sending: false, sent: false, error: 'Envoi impossible, réessayez dans un instant.' }));
  };

  return (
    <form className="ms-rsvp" onSubmit={handleSubmit}>
      <input
        className="ms-input"
        placeholder="Prénom et nom"
        value={nom}
        onChange={(e) => setNom(e.target.value)}
        maxLength={120}
        required
      />
      <div className="ms-choice">
        <button type="button" className={presence === true ? 'is-active' : ''} onClick={() => setPresence(true)}>
          Je serai là
        </button>
        <button type="button" className={presence === false ? 'is-active' : ''} onClick={() => setPresence(false)}>
          Je ne pourrai pas venir
        </button>
      </div>

      {presence === true && params.rsvp_accompagnants && (
        <label className="ms-field">
          {params.rsvp_enfants ? 'Nombre d\'adultes (vous compris)' : 'Nombre de personnes (vous compris)'}
          <input
            className="ms-input"
            type="number"
            min="1"
            max="20"
            value={nbPersonnes}
            onChange={(e) => setNbPersonnes(e.target.value)}
          />
        </label>
      )}

      {presence === true && params.rsvp_enfants && (
        <label className="ms-field">
          Nombre d'enfants
          <input
            className="ms-input"
            type="number"
            min="0"
            max="20"
            value={nbEnfants}
            onChange={(e) => setNbEnfants(e.target.value)}
          />
        </label>
      )}

      {presence === true && params.rsvp_repas && repasOptions.length > 0 && (
        <label className="ms-field">
          Choix du repas
          <select className="ms-input" value={repas} onChange={(e) => setRepas(e.target.value)}>
            <option value="">— Choisir —</option>
            {repasOptions.map((option) => <option key={option} value={option}>{option}</option>)}
          </select>
        </label>
      )}

      {presence === true && params.rsvp_allergies && (
        <input
          className="ms-input"
          placeholder="Allergies ou régime particulier"
          value={allergies}
          onChange={(e) => setAllergies(e.target.value)}
          maxLength={255}
        />
      )}

      {presence === true && questions.map((question, index) => (
        <label className="ms-field" key={index}>
          {question}
          <input
            className="ms-input"
            value={reponses[index] || ''}
            onChange={(e) => setReponses((prev) => { const next = [...prev]; next[index] = e.target.value; return next; })}
            maxLength={300}
          />
        </label>
      ))}

      {params.rsvp_message_invite !== false && (
        <textarea
          className="ms-input"
          placeholder="Un petit mot (facultatif)"
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          maxLength={1000}
        />
      )}

      {status.error && <p className="ms-error">{status.error}</p>}
      <button type="submit" className="ms-submit" disabled={status.sending || preview}>
        {preview ? 'Envoyer (désactivé dans cet exemple)' : status.sending ? 'Envoi…' : 'Envoyer ma réponse'}
      </button>
    </form>
  );
};

export default MinisiteRsvpForm;
